import React, { useState } from 'react';
import { Lock, Loader2, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin } from '../services/adminApi';
import { setStoredAdminPassword } from '../services/adminAuth';

export default function AdminLogin({ onAuthed }) {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!password) { setError('Ingresa la clave.'); return; }
        setBusy(true);
        try {
            await loginAdmin(password);
            setStoredAdminPassword(password);
            onAuthed?.();
        } catch (err) {
            setError(err.message || 'Error al validar clave');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-6 bg-bg-900">
            <div className="w-full max-w-sm">
                <button
                    type="button"
                    onClick={() => navigate('/')}
                    className="flex items-center gap-1.5 text-slate-400 hover:text-neon-cyan text-sm mb-6 transition-colors font-mono uppercase tracking-wider"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Volver al simulador
                </button>

                <div className="bg-bg-800/95 backdrop-blur border border-neon-cyan/30 rounded-2xl p-7 shadow-[0_0_24px_rgba(34,211,238,0.15)]">
                    <div className="flex items-center gap-3 mb-5">
                        <div className="w-10 h-10 rounded-xl bg-neon-cyan/10 border border-neon-cyan/30 flex items-center justify-center">
                            <Lock className="w-5 h-5 text-neon-cyan" />
                        </div>
                        <div>
                            <h1 className="text-base font-bold text-white font-mono uppercase tracking-wider">Acceso restringido</h1>
                            <p className="text-xs text-slate-400 mt-0.5">Ingresa la clave de admin</p>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <input
                            type="password"
                            autoFocus
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Clave"
                            disabled={busy}
                            className="w-full bg-bg-900/60 border border-bg-700 rounded-xl px-3 py-2.5 text-sm text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-neon-cyan/40 focus:border-neon-cyan/50"
                        />
                        {error && (
                            <p className="text-sm text-red-300 bg-red-900/30 border border-red-700/40 rounded-lg px-3 py-2">
                                {error}
                            </p>
                        )}
                        <button
                            type="submit"
                            disabled={busy}
                            className="w-full flex items-center justify-center gap-2 text-bg-900 font-mono font-bold uppercase tracking-wider text-sm px-4 py-2.5 rounded-xl transition-all hover:scale-[1.02] disabled:opacity-60 shadow-[0_0_16px_rgba(163,230,53,0.4)]"
                            style={{ background: '#a3e635' }}
                        >
                            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                            Entrar
                        </button>
                    </form>
                </div>

                <p className="text-[11px] text-slate-500 mt-4 text-center font-mono">
                    La sesión vive solo mientras esta pestaña esté abierta.
                </p>
            </div>
        </div>
    );
}
